export default "__VITE_ASSET__Dka2QNT0__"